(() => {
  const getProxyBase = () =>
    window.location.host.includes("staging")
      ? "/apps/didomi-consents-staging"
      : "/apps/didomi-consents";

  const updateTagsInput = (container, value, action) => {
    const tagsInput = container.querySelector(
      'form input[name="contact[tags]"]'
    );
    if (!tagsInput) return;
    const tags = tagsInput.value ? tagsInput.value.split(",") : [];
    if (action === "insert") {
      if (!tags.includes(value)) {
        tags.push(value);
      }
    } else {
      tagsInput.value = tags.filter((tag) => tag !== value).join(",");
      return;
    }
    tagsInput.value = tags.join(",");
  };

  const bindConsentCheckbox = (container, checkbox) => {
    if (!checkbox) return false;
    checkbox.addEventListener("change", (event) => {
      const checked = event.currentTarget.checked;
      updateTagsInput(
        container,
        event.currentTarget.value,
        checked ? "insert" : "remove"
      );
    });
    return true;
  };

  const getConsentState = (container) => {
    const privacy = container.querySelector("#NewsletterForm-privacy-consent");
    const marketing = container.querySelector("#NewsletterForm-marketing-consent");
    const profiling = container.querySelector("#NewsletterForm-profiling-consent");
    return {
      privacy: privacy?.checked === true,
      marketing: marketing?.checked === true,
      profiling: profiling?.checked === true,
    };
  };

  const hasRequiredConsents = (container) => {
    const { privacy, marketing } = getConsentState(container);
    return privacy && marketing;
  };

  const isLoggedCustomer = () =>
    Boolean(
      window.ShopifyAnalytics?.meta?.page?.customerId
    );

  const checkAlreadySubscribed = async (email) => {
    const formData = new FormData();
    formData.set("email", email);
    const response = await fetch(`${getProxyBase()}/api/newsletter/check`, {
      method: "POST",
      body: formData,
    });
    const json = await response.json();
    return json?.subscribed === true;
  };

  const sendNewsletterConsents = async (container) => {
    const consents = [];
    const privacy = container.querySelector("#NewsletterForm-privacy-consent");
    const marketing = container.querySelector("#NewsletterForm-marketing-consent");
    const profiling = container.querySelector("#NewsletterForm-profiling-consent");
    if (privacy?.checked) consents.push("privacy-consent");
    if (marketing?.checked) consents.push("marketing-consent");
    if (profiling?.checked) consents.push("profiling-consent");
    const formData = new FormData();
    formData.set("consents", consents);
    await fetch(`${getProxyBase()}/api/newsletter/subscribe`, {
      method: "POST",
      body: formData,
    });
  };

  const initNewsletter = (container) => {
    const form = container.querySelector("form");
    if (!form) return;

    const privacyCheckbox = container.querySelector(
      "#NewsletterForm-privacy-consent"
    );
    if (!privacyCheckbox) return;

    bindConsentCheckbox(container, privacyCheckbox);
    bindConsentCheckbox(
      container,
      container.querySelector("#NewsletterForm-marketing-consent")
    );
    bindConsentCheckbox(
      container,
      container.querySelector("#NewsletterForm-profiling-consent")
    );

    const emailInput = form.querySelector('input[name="contact[email]"]');
    const submitButton =
      form.querySelector('button[type="submit"]') ||
      form.querySelector('button[name="commit"]');
    const missingConsentsMessage = container.querySelector(
      ".consent-messages .missing-consents"
    );
    const alreadySubscribedMessage = container.querySelector(
      ".consent-messages .already-subscribed"
    );

    emailInput?.addEventListener("input", () => {
      delete form.dataset.subscriptionStatus;
    });

    submitButton?.addEventListener("click", async (event) => {
      event.preventDefault();
      event.stopImmediatePropagation();

      missingConsentsMessage?.classList.add("hidden");
      alreadySubscribedMessage?.classList.add("hidden");

      if (!hasRequiredConsents(container)) {
        missingConsentsMessage?.classList.remove("hidden");
        return;
      }

      if (!form.checkValidity()) {
        form.reportValidity();
        missingConsentsMessage?.classList.remove("hidden");
        return;
      }

      const email = emailInput?.value?.trim();
      if (!email) {
        missingConsentsMessage?.classList.remove("hidden");
        return;
      }

      const status = form.dataset.subscriptionStatus;
      if (status === "subscribed") {
        alreadySubscribedMessage?.classList.remove("hidden");
        return;
      }

      if (status !== "unsubscribed") {
        try {
          const isSubscribed = await checkAlreadySubscribed(email);
          if (isSubscribed) {
            form.dataset.subscriptionStatus = "subscribed";
            alreadySubscribedMessage?.classList.remove("hidden");
            return;
          }
          form.dataset.subscriptionStatus = "unsubscribed";
        } catch (error) {
          console.error(error);
        }
      }

      try {
        if (isLoggedCustomer()) {
          await sendNewsletterConsents(container);
        }
      } catch (error) {
        console.error(error);
      }

      form.submit();
    });
  };

  const init = () => {
    document.querySelectorAll(".newsletter").forEach(initNewsletter);
    document.querySelectorAll(".subscription-popup").forEach(initNewsletter);
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
